import { render } from "./NavMenuList.vue?vue&type=template&id=2dd8a03f&scoped=true"
import script from "./NavMenuList.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenuList.vue?vue&type=script&setup=true&lang=js"

import "./NavMenuList.vue?vue&type=style&index=0&id=2dd8a03f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd8a03f"],['__file',"src/components/app/sidebar/NavMenuList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dd8a03f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dd8a03f', __exports__)) {
    api.reload('2dd8a03f', __exports__)
  }
  
  module.hot.accept("./NavMenuList.vue?vue&type=template&id=2dd8a03f&scoped=true", () => {
    api.rerender('2dd8a03f', render)
  })

}


export default __exports__